<template>
  <div class="clock_header">
    <vs-card id="data-loading">
      <div class="vx-row pt-5 px-5">
        <div class="vx-col w-full lg:w-5/12 md:w-1/2">
          <!-- from date -->
          <div class="vx-row mb-2 items-center">
            <div class="vx-col w-2/5 text-right">
              <h6>Start Date</h6>
            </div>
            <div class="vx-col w-3/5 relative">
              <date-picker :appendToBody="false" v-model="start_date" name="Report From Date" placeholder="MM-DD-YYYY" v-validate="'required'" format="MM-DD-YYYY" valueType="format" class="w-full" />
              <span class="text-danger text-sm" v-show="errors.has('Report From Date')">{{ errors.first('Report From Date') }}</span>
            </div>
          </div>

          <!-- client -->
          <div class="vx-row mb-2 items-center">
            <div class="vx-col w-2/5 text-right">
              <h6>User</h6>
            </div>
            <div class="vx-col w-3/5">
              <select-2
                class="w-full"
                autocomplete
                :value="employerId"
                @input="(elem) => (employerId = elem.value)"
                placeholder="Please Select User"
                name="Employer"
                :options="emplotersOptions"
                v-validate="'required'"
              />
              <span class="text-danger text-sm" v-show="errors.has('Employer')">{{ errors.first('Employer') }}</span>
            </div>
          </div>
        </div>

        <div class="vx-col w-full lg:w-5/12 md:w-1/2">
          <!-- to date -->
          <div class="vx-row mb-2 items-center">
            <div class="vx-col w-2/5 text-right">
              <h6>End Date</h6>
            </div>
            <div class="vx-col w-3/5 relative">
              <date-picker :appendToBody="false" v-model="end_date" name="Report End Date" placeholder="MM-DD-YYYY" v-validate="'required'" format="MM-DD-YYYY" valueType="format" class="w-full" />
              <span class="text-danger text-sm" v-show="errors.has('Report End Date')">{{ errors.first('Report End Date') }}</span>
            </div>
          </div>
        </div>
      </div>

      <hr class="mt-5 border border-black" />

      <div class="filter__btns text-center">
        <vs-button color="success" class="m-5 mb-0 md:w-1/5" type="filled" @click="showResults">Show</vs-button>
      </div>
    </vs-card>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import Select2 from '@/components/custom/form-elements/Select2.vue'
import moment from 'moment'
import { mapActions } from 'vuex'

export default {
  name: 'ClockHeader',

  components: {
    DatePicker,
    Select2
  },

  data() {
    return {
      start_date: moment().format('MM-DD-YYYY'),
      end_date: moment().format('MM-DD-YYYY'),
      emplotersOptions: [],
      employerId: null,
      order: [],
      length: 10,
      page: 1
    }
  },

  async mounted() {
    this.$store
      .dispatch('punch_clock/getEmployerList', { page: 1, limit: 0 })
      .then((res) => {
        this.emplotersOptions = res.data.reduce((acc, item) => {
          item.label = item.username
          item.value = parseInt(item.id)
          acc.push(item)

          return acc
        }, [])
      })
      .catch((err) => {
        const { message } = err
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
  },

  computed: {
    //   validate form
    validateForm() {
      return !this.errors.any()
    }
  },

  methods: {
    ...mapActions('punch_clock', { fetchPunchClockList: 'getPunchClockList' }),

    async getData() {
      const { order, length, page, start_date, end_date, employerId } = this
      await this.fetchPunchClockList({
        order,
        limit: length,
        page,
        start_date,
        end_date,
        employerId
      })
    },

    async showResults() {
      if (!(await this.$validator.validate())) {
        return false
      }

      this.getData()
    }
  }
}
</script>

<style></style>
